/*
 * @Author: cong
 * @Date: 2021-11-08 19:38:09
 * @LastEditTime: 2021-11-24 09:36:42
 * @LastEditors: cong
 * @Description:
 * @FilePath: \qlh-vue-web\src\api\oa\cwcapitals.js
 */
import { ApiUtils, _axios } from "@/api/apiUtil.js";
import constant from "@/util/constant.js";
const api = {
  list: (params, successCallback, failCallback, exceptionCallback) => {
    ApiUtils.getLoadingAjax(
      constant.serverUrl + "/oa/cw2/list",
      params,
      successCallback,
      failCallback,
      exceptionCallback
    );
  },
  save: (params, successCallback, failCallback, exceptionCallback) => {
    ApiUtils.postLoadingAjax(
      constant.serverUrl + "/oa/cw2/save",
      params,
      successCallback,
      failCallback,
      exceptionCallback
    );
  },
  toUpdate: (params, successCallback, failCallback, exceptionCallback) => {
    ApiUtils.getLoadingAjax(
      constant.serverUrl + "/oa/cw2/toUpdate",
      params,
      successCallback,
      failCallback,
      exceptionCallback
    );
  },
  update: (params, successCallback, failCallback, exceptionCallback) => {
    ApiUtils.putLoadingAjax(
      constant.serverUrl + "/oa/cw2/update",
      params,
      successCallback,
      failCallback,
      exceptionCallback
    );
  },
  updateDan: (params, successCallback, failCallback, exceptionCallback) => {
    ApiUtils.putLoadingAjax(
      constant.serverUrl + "/oa/cw2/updatedan",
      params,
      successCallback,
      failCallback,
      exceptionCallback
    );
  },
  importData: (params, successCallback, failCallback, exceptionCallback) => {
    ApiUtils.postLoadingAjax(
      constant.serverUrl + "/oa/cw2/import",
      params,
      successCallback,
      failCallback,
      exceptionCallback
    );
  },

  updateCheck: (params, successCallback, failCallback, exceptionCallback) => {
    ApiUtils.putLoadingAjax(
      constant.serverUrl + "/oa/cw2/updateCheck",
      params,
      successCallback,
      failCallback,
      exceptionCallback
    );
  },
  remove: (params, successCallback, failCallback, exceptionCallback) => {
    ApiUtils.deleteLoadingAjax(
      constant.serverUrl + "/oa/cw2/remove",
      params,
      successCallback,
      failCallback,
      exceptionCallback
    );
  },
  toPush: (params, successCallback, failCallback, exceptionCallback) => {
    ApiUtils.getLoadingAjax(
      constant.serverUrl + "/oa/cw2/toPush",
      params,
      successCallback,
      failCallback,
      exceptionCallback
    );
  },
  updateCwcapitals: (
    params,
    successCallback,
    failCallback,
    exceptionCallback
  ) => {
    ApiUtils.getLoadingAjax(
      constant.serverUrl + "/oa/cw2/updateCwcapitals",
      params,
      successCallback,
      failCallback,
      exceptionCallback
    );
  },
  downloadCwcapitals: (data, params, headers) => {
    //url, method, data, params, headers
    ApiUtils.sendDownFile(
      constant.serverUrl + "/oa/download/downloadCwcapitals",
      "get",
      data,
      params,
      headers
    );
  },
  deletekey: (params, successCallback, failCallback, exceptionCallback) => {
    ApiUtils.deleteLoadingAjax(
      constant.serverUrl + "/oa/download/deletekey",
      params,
      successCallback,
      failCallback,
      exceptionCallback
    );
  },
  getReport: (params, successCallback, failCallback, exceptionCallback) => {
    ApiUtils.getLoadingAjax(
      constant.serverUrl + "/oa/cw2/listRpt",
      params,
      successCallback,
      failCallback,
      exceptionCallback
    );
  },
};

export default api;
